import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

const featuredJobs = [
  {
    id: "r1",
    title: "Warehouse Associate",
    company: "TechVision Factory",
    bossName: "Mike Chen",
    bossTitle: "HR Manager",
    bossAvatar: "https://public.readdy.ai/ai/img_res/f3a93caa10e896b9a0a89cff056fde43.jpg",
    online: true,
    location: "Los Angeles, CA",
    type: "Full-time",
    salary: "$18 - $22/hr",
    category: "Warehouse",
    icon: "ri-box-3-line",
    color: "bg-orange-50 text-orange-600",
    badge: "Urgent Hire",
    badgeColor: "bg-red-100 text-red-600",
    perks: ["Health Insurance", "Paid Training", "Overtime Pay"],
    logo: "https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20woman%20working%20in%20bright%20modern%20USA%20warehouse%20smiling%20confident%20professional%20uniform%20clean%20facility%20white%20background&width=400&height=240&seq=rec-job1-blonde&orientation=landscape",
    replyTime: "Replies in ~5 min",
    autoReply: "Hi! Thanks for reaching out about the Warehouse Associate role. We are actively hiring and would love to learn more about you. What is your availability to start?",
  },
  {
    id: "r2",
    title: "Social Media & Content Creator",
    company: "PureGlow Labs",
    bossName: "Jessica Park",
    bossTitle: "Creative Director",
    bossAvatar: "https://readdy.ai/api/search-image?query=gorgeous%20blonde%20hair%20young%20woman%20creative%20director%20smiling%20headshot%20portrait%20clean%20white%20background%20beauty%20glamorous%20attractive%20professional&width=60&height=60&seq=boss2-blonde&orientation=squarish",
    online: true,
    location: "Miami, FL (Remote OK)",
    type: "Part-time",
    salary: "$25 - $40/hr",
    category: "Marketing",
    icon: "ri-camera-line",
    color: "bg-pink-50 text-pink-600",
    badge: "Remote Friendly",
    badgeColor: "bg-green-100 text-green-600",
    perks: ["Flexible Hours", "Free Products", "Commission Bonus"],
    logo: "https://readdy.ai/api/search-image?query=gorgeous%20blonde%20hair%20young%20woman%20content%20creator%20filming%20beauty%20products%20bright%20studio%20smiling%20glamorous%20attractive%20white%20background%20colorful&width=400&height=240&seq=rec-job2-blonde&orientation=landscape",
    replyTime: "Replies in ~10 min",
    autoReply: "Hey! So excited you are interested in our Content Creator role! Do you have a TikTok or Instagram portfolio you can share? We love seeing creative work!",
  },
  {
    id: "r3",
    title: "E-Commerce Sales Rep",
    company: "GreenThread Mills",
    bossName: "David Torres",
    bossTitle: "Sales Director",
    bossAvatar: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20sales%20director%20smiling%20headshot%20portrait%20clean%20white%20background%20business%20suit%20attractive%20confident%20charming%20blue%20eyes&width=60&height=60&seq=boss3-handsome&orientation=squarish",
    online: false,
    location: "New York, NY",
    type: "Full-time",
    salary: "$45K - $60K + Commission",
    category: "Sales",
    icon: "ri-store-2-line",
    color: "bg-emerald-50 text-emerald-600",
    badge: "High Earning",
    badgeColor: "bg-yellow-100 text-yellow-700",
    perks: ["Uncapped Commission", "401K", "Career Growth"],
    logo: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20and%20beautiful%20blonde%20woman%20sales%20team%20USA%20modern%20bright%20office%20smiling%20confident%20attractive%20professional%20white%20background&width=400&height=240&seq=rec-job3-handsome&orientation=landscape",
    replyTime: "Replies within 1 hour",
    autoReply: "Thanks for your interest in our Sales Rep position! We offer uncapped commission — our top reps earn $90K+. Can you tell me about your sales background?",
  },
  {
    id: "r4",
    title: "Logistics & Delivery Coordinator",
    company: "HydroForge Co.",
    bossName: "Amanda Lee",
    bossTitle: "Operations Manager",
    bossAvatar: "https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20woman%20operations%20manager%20smiling%20headshot%20portrait%20clean%20white%20background%20professional%20confident%20attractive%20bright%20smile&width=60&height=60&seq=boss4-blonde&orientation=squarish",
    online: true,
    location: "Houston, TX",
    type: "Full-time",
    salary: "$50K - $65K/yr",
    category: "Logistics",
    icon: "ri-truck-line",
    color: "bg-sky-50 text-sky-600",
    badge: "Benefits Package",
    badgeColor: "bg-sky-100 text-sky-700",
    perks: ["Medical & Dental", "Paid Time Off", "Signing Bonus"],
    logo: "https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20woman%20logistics%20coordinator%20USA%20warehouse%20smiling%20confident%20professional%20bright%20modern%20facility%20white%20background%20attractive&width=400&height=240&seq=rec-job4-blonde&orientation=landscape",
    replyTime: "Replies in ~3 min",
    autoReply: "Hello! Great timing — we just opened this position. We offer a $500 signing bonus and full benefits from day one. Are you based in Houston or willing to relocate?",
  },
  {
    id: "r5",
    title: "Customer Support Specialist",
    company: "FitForge Manufacturing",
    bossName: "Ryan Brooks",
    bossTitle: "Team Lead",
    bossAvatar: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20team%20lead%20smiling%20headshot%20portrait%20clean%20white%20background%20customer%20service%20attractive%20confident%20charming%20strong%20jawline&width=60&height=60&seq=boss5-handsome&orientation=squarish",
    online: true,
    location: "Phoenix, AZ (Remote)",
    type: "Full-time",
    salary: "$38K - $48K/yr",
    category: "Support",
    icon: "ri-headphone-line",
    color: "bg-violet-50 text-violet-600",
    badge: "Work From Home",
    badgeColor: "bg-green-100 text-green-600",
    perks: ["100% Remote", "Equipment Provided", "Bilingual Bonus"],
    logo: "https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20young%20woman%20working%20from%20home%20laptop%20headset%20smiling%20bright%20home%20office%20setup%20attractive%20glamorous%20white%20background&width=400&height=240&seq=rec-job5-blonde&orientation=landscape",
    replyTime: "Replies in ~8 min",
    autoReply: "Hi there! This is a fully remote role — we ship you all the equipment you need. Do you speak Spanish? We offer a $3K/yr bilingual bonus!",
  },
  {
    id: "r6",
    title: "Product Photography Specialist",
    company: "SoundWave Factory",
    bossName: "Olivia Kim",
    bossTitle: "Creative Manager",
    bossAvatar: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20creative%20manager%20smiling%20headshot%20portrait%20clean%20white%20background%20photography%20attractive%20confident%20charming%20stylish&width=60&height=60&seq=boss6-handsome&orientation=squarish",
    online: false,
    location: "Chicago, IL",
    type: "Contract",
    salary: "$35 - $55/hr",
    category: "Creative",
    icon: "ri-image-line",
    color: "bg-amber-50 text-amber-600",
    badge: "Creative Role",
    badgeColor: "bg-amber-100 text-amber-700",
    perks: ["Portfolio Building", "Studio Access", "Flexible Schedule"],
    logo: "https://readdy.ai/api/search-image?query=handsome%20young%20man%20product%20photographer%20studio%20setup%20professional%20camera%20lighting%20equipment%20modern%20creative%20space%20attractive%20confident%20stylish%20white%20background&width=400&height=240&seq=rec-job6-handsome&orientation=landscape",
    replyTime: "Replies within 2 hours",
    autoReply: "Hey! We are looking for a talented photographer to shoot our electronics catalog. Do you have studio lighting experience? Please share your portfolio link!",
  },
];

const stats = [
  { icon: "ri-briefcase-4-line", value: "2,400+", label: "Open Positions" },
  { icon: "ri-message-3-line", value: "Direct", label: "Chat with Boss" },
  { icon: "ri-map-pin-2-line", value: "48", label: "States Covered" },
  { icon: "ri-timer-flash-line", value: "< 10 min", label: "Avg. Reply Time" },
];

const categories = ["All", "Warehouse", "Marketing", "Sales", "Logistics", "Support", "Creative"];

interface ChatMessage {
  sender: "user" | "boss";
  text: string;
  time: string;
}

interface ChatState {
  jobId: string;
  messages: ChatMessage[];
  input: string;
  replied: boolean;
}

export default function RecruitmentSection() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [hoveredJob, setHoveredJob] = useState<string | null>(null);
  const [chat, setChat] = useState<ChatState | null>(null);
  const [typing, setTyping] = useState(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);

  const filtered = activeCategory === "All"
    ? featuredJobs
    : featuredJobs.filter((j) => j.category === activeCategory);

  const activeJob = chat ? featuredJobs.find((j) => j.id === chat.jobId) : null;

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chat?.messages, typing]);

  const openChat = (job: typeof featuredJobs[0]) => {
    setChat({
      jobId: job.id,
      messages: [
        {
          sender: "boss",
          text: job.autoReply,
          time: "Just now",
        },
      ],
      input: "",
      replied: false,
    });
  };

  const sendMessage = () => {
    if (!chat || !chat.input.trim() || !activeJob) return;
    const userMsg: ChatMessage = { sender: "user", text: chat.input.trim(), time: "Just now" };
    setChat((prev) => prev ? { ...prev, messages: [...prev.messages, userMsg], input: "", replied: false } : prev);
    setTyping(true);

    const replies = [
      "That sounds great! We would love to schedule a quick 15-minute call. What time works best for you this week?",
      "Perfect! Can you send us your resume? You can also apply directly on our recruitment page.",
      "Awesome! We are moving fast on this role. Are you available to start within the next 2 weeks?",
      "Great to hear! We will have our HR team reach out to you by email within 24 hours.",
      "Excellent! We think you would be a great fit. Let us set up an interview — does Tuesday or Wednesday work?",
    ];
    const reply = replies[Math.floor(Math.random() * replies.length)];

    setTimeout(() => {
      setTyping(false);
      setChat((prev) =>
        prev ? {
          ...prev,
          messages: [...prev.messages, { sender: "boss", text: reply, time: "Just now" }],
          replied: true,
        } : prev
      );
    }, 1800);
  };

  return (
    <section className="py-20 bg-white relative">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-0.5 bg-orange-500 rounded-full" />
              <span className="text-orange-500 text-sm font-bold uppercase tracking-widest">Now Hiring · USA Only</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight mb-3">
              Find Your Dream Job<br />
              <span className="text-orange-500">Right Here in the USA</span>
            </h2>
            <div className="max-w-2xl mb-4">
              <p className="text-2xl md:text-3xl font-extrabold text-gray-800 leading-snug">
                Chat directly with factory bosses,
              </p>
              <p className="text-2xl md:text-3xl font-extrabold leading-snug">
                <span className="text-orange-500">get instant replies</span>
                <span className="text-gray-800">, and land your</span>
              </p>
              <p className="text-2xl md:text-3xl font-extrabold text-gray-800 leading-snug">
                dream job <span className="text-orange-500">fast.</span>
              </p>

            </div>
            {/* Live chat badge */}
            <div className="inline-flex items-center gap-2 bg-green-50 border border-green-200 text-green-700 text-xs font-bold px-4 py-2 rounded-full">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              4 Factory Bosses Online Now — Chat Instantly
            </div>
          </div>
          <Link
            to="/recruitment"
            className="inline-flex items-center gap-2 bg-gray-900 text-white px-7 py-3.5 rounded-full font-bold text-sm hover:bg-orange-500 transition-colors cursor-pointer whitespace-nowrap flex-shrink-0"
          >
            <i className="ri-briefcase-4-line" />
            Browse All Jobs
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
          {stats.map((s) => (
            <div key={s.label} className="bg-orange-50 rounded-2xl p-5 flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-xl flex-shrink-0">
                <i className={`${s.icon} text-orange-500 text-xl`} />
              </div>
              <div>
                <div className="text-2xl font-extrabold text-gray-900">{s.value}</div>
                <div className="text-xs text-gray-500 font-medium">{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* How it works strip */}
        <div className="bg-gray-900 rounded-2xl px-6 py-5 mb-10 flex flex-col sm:flex-row items-center gap-4 sm:gap-0">
          {[
            { step: "1", icon: "ri-shield-check-fill", text: "All jobs from verified USA factories & companies only" },
            { step: "2", icon: "ri-message-3-line", text: "Chat directly with the boss — no middlemen" },
            { step: "3", icon: "ri-gift-line", text: "Apply & send resume FREE — always, for all USA citizens" },
          ].map((s, i) => (
            <div key={s.step} className="flex items-center gap-3 flex-1">
              <div className="w-9 h-9 flex items-center justify-center bg-orange-500 rounded-full flex-shrink-0 text-white font-extrabold text-sm">{s.step}</div>
              <div className="flex items-center gap-2">
                <i className={`${s.icon} text-orange-400 text-lg`} />
                <span className="text-white text-xs font-medium">{s.text}</span>
              </div>
              {i < 2 && <i className="ri-arrow-right-line text-gray-600 text-lg hidden sm:block ml-auto" />}
            </div>
          ))}
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap gap-2 mb-8">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === cat
                  ? "bg-orange-500 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-orange-50 hover:text-orange-600"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Job Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {filtered.map((job) => (
            <div
              key={job.id}
              onMouseEnter={() => setHoveredJob(job.id)}
              onMouseLeave={() => setHoveredJob(null)}
              className="bg-white border border-gray-100 rounded-2xl overflow-hidden transition-all duration-300 hover:border-orange-200 hover:-translate-y-1"
            >
              {/* Job Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={job.logo}
                  alt={job.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500"
                  style={{ transform: hoveredJob === job.id ? "scale(1.05)" : "scale(1)" }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                <span className={`absolute top-3 left-3 text-xs font-bold px-3 py-1 rounded-full ${job.badgeColor}`}>
                  {job.badge}
                </span>
                <span className={`absolute bottom-3 left-3 text-xs font-semibold px-3 py-1.5 rounded-full ${job.color} bg-white/90`}>
                  <i className={`${job.icon} mr-1`} />
                  {job.category}
                </span>
                {/* Boss avatar overlay */}
                <div className="absolute bottom-3 right-3 flex items-center gap-1.5 bg-white/90 rounded-full pl-1 pr-2.5 py-1">
                  <div className="relative">
                    <img src={job.bossAvatar} alt={job.bossName} className="w-6 h-6 rounded-full object-cover object-top" />
                    {job.online && <span className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 bg-green-500 rounded-full border border-white" />}
                  </div>
                  <span className="text-xs font-semibold text-gray-700">{job.online ? "Online" : "Away"}</span>
                </div>
              </div>

              {/* Job Info */}
              <div className="p-5">
                <h3 className="font-bold text-gray-900 text-base mb-1">{job.title}</h3>
                <div className="flex items-center gap-1.5 mb-3">
                  <i className="ri-building-line text-gray-400 text-xs" />
                  <span className="text-xs text-gray-500">{job.company}</span>
                  <i className="ri-shield-check-fill text-green-500 text-xs" title="Verified Employer" />
                  <span className="text-xs text-green-600 font-semibold">Verified</span>
                </div>

                <div className="flex flex-wrap gap-2 mb-3">
                  <span className="flex items-center gap-1 text-xs bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full">
                    <i className="ri-map-pin-line" />{job.location}
                  </span>
                  <span className="flex items-center gap-1 text-xs bg-orange-50 text-orange-600 px-2.5 py-1 rounded-full font-semibold">
                    <i className="ri-money-dollar-circle-line" />{job.salary}
                  </span>
                </div>

                {/* Perks */}
                <div className="flex flex-wrap gap-1.5 mb-4">
                  {job.perks.map((perk) => (
                    <span key={perk} className="text-xs bg-gray-50 border border-gray-100 text-gray-500 px-2 py-0.5 rounded-full">
                      {perk}
                    </span>
                  ))}
                </div>

                {/* Boss info row */}
                <div className="flex items-center gap-2 mb-4 bg-gray-50 rounded-xl p-2.5">
                  <img src={job.bossAvatar} alt={job.bossName} className="w-8 h-8 rounded-full object-cover object-top flex-shrink-0" />
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-bold text-gray-800 truncate">{job.bossName}</p>
                    <p className="text-xs text-gray-400 truncate">{job.bossTitle} · {job.replyTime}</p>
                  </div>
                  {job.online && <span className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0" />}
                </div>

                {/* Action Buttons */}
                <div className="flex gap-2">
                  <button
                    onClick={() => openChat(job)}
                    className="flex-1 flex items-center justify-center gap-1.5 py-2.5 bg-orange-500 text-white text-xs font-bold rounded-xl hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-message-3-line" /> Chat with Boss
                  </button>
                  <Link
                    to="/recruitment"
                    className="flex-1 flex items-center justify-center gap-1.5 py-2.5 border border-gray-200 text-gray-700 text-xs font-semibold rounded-xl hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-gift-line text-green-500" /> Apply Free
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA Banner */}
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=beautiful%20blonde%20hair%20woman%20employer%20boss%20sitting%20at%20modern%20office%20desk%20smiling%20confident%20professional%20USA%20bright%20workspace%20attractive%20businesswoman%20in%20charge%20looking%20at%20camera%20clean%20background&width=1400&height=320&seq=rec-cta-blonde-boss&orientation=landscape"
            alt="Join USA workforce"
            className="w-full h-64 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/90 via-gray-900/70 to-transparent" />
          <div className="absolute inset-0 flex items-center px-8 md:px-14">
            <div className="max-w-lg">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-star-fill text-orange-400 text-sm" />
                <span className="text-orange-400 text-sm font-bold uppercase tracking-wider">For Young USA Citizens</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-extrabold text-white mb-2 leading-tight">
                Chat Directly with the Boss.<br />Get Hired in Days, Not Weeks.
              </h3>
              <p className="text-gray-300 text-sm mb-1">
                Every job is from a <strong className="text-white">verified factory or company</strong>. No scams, no fake listings.
              </p>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex items-center gap-1.5 text-xs bg-green-500/20 border border-green-400/40 text-green-300 font-bold px-3 py-1.5 rounded-full">
                  <i className="ri-gift-line" /> Apply &amp; Resume — FREE for USA Citizens
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs bg-white/10 border border-white/20 text-gray-300 font-bold px-3 py-1.5 rounded-full">
                  <i className="ri-shield-check-fill text-orange-400" /> Employers pay $5/mo
                </span>
              </div>
              <div className="flex flex-wrap gap-3">
                <Link
                  to="/recruitment"
                  className="inline-flex items-center gap-2 bg-orange-500 text-white px-7 py-3 rounded-full font-bold text-sm hover:bg-orange-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-message-3-line" />
                  Start Chatting Now
                </Link>
                <Link
                  to="/recruitment"
                  className="inline-flex items-center gap-2 bg-white/10 border border-white/30 text-white px-7 py-3 rounded-full font-bold text-sm hover:bg-white/20 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-briefcase-4-line" />
                  Browse All Jobs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── Floating Chat Window ── */}
      {chat && activeJob && (
        <div className="fixed bottom-6 right-6 z-50 w-80 bg-white rounded-2xl overflow-hidden border border-gray-200 flex flex-col" style={{ height: "420px" }}>
          {/* Chat Header */}
          <div className="flex items-center gap-3 px-4 py-3 bg-gray-900 flex-shrink-0">
            <div className="relative flex-shrink-0">
              <img src={activeJob.bossAvatar} alt={activeJob.bossName} className="w-9 h-9 rounded-full object-cover object-top" />
              {activeJob.online && <span className="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-green-500 rounded-full border-2 border-gray-900" />}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-white text-xs font-bold truncate">{activeJob.bossName}</p>
              <p className="text-gray-400 text-xs truncate">{activeJob.bossTitle} · {activeJob.company}</p>
            </div>
            <button
              onClick={() => setChat(null)}
              className="w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-sm" />
            </button>
          </div>

          {/* Job context pill */}
          <div className="px-3 py-2 bg-orange-50 border-b border-orange-100 flex-shrink-0">
            <p className="text-xs text-orange-700 font-semibold truncate">
              <i className="ri-briefcase-line mr-1" />{activeJob.title} · {activeJob.salary}
            </p>
          </div>

          {/* Messages */}
          <div className="flex-1 overflow-y-auto p-3 space-y-3">
            {chat.messages.map((msg, i) => (
              <div key={i} className={`flex gap-2 ${msg.sender === "user" ? "flex-row-reverse" : ""}`}>
                {msg.sender === "boss" && (
                  <img src={activeJob.bossAvatar} alt="" className="w-6 h-6 rounded-full object-cover object-top flex-shrink-0 mt-0.5" />
                )}
                <div className={`max-w-[200px] px-3 py-2 rounded-2xl text-xs leading-relaxed ${msg.sender === "user" ? "bg-orange-500 text-white rounded-tr-sm" : "bg-gray-100 text-gray-800 rounded-tl-sm"}`}>
                  {msg.text}
                </div>
              </div>
            ))}
            {typing && (
              <div className="flex gap-2 items-center">
                <img src={activeJob.bossAvatar} alt="" className="w-6 h-6 rounded-full object-cover object-top flex-shrink-0" />
                <div className="bg-gray-100 rounded-2xl rounded-tl-sm px-3 py-2 flex items-center gap-1">
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                  <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Quick reply chips */}
          {!chat.replied && chat.messages.length === 1 && (
            <div className="px-3 pb-2 flex flex-wrap gap-1.5 flex-shrink-0">
              {["I am interested!", "When can I start?", "Is this remote?"].map((q) => (
                <button
                  key={q}
                  onClick={() => setChat((prev) => prev ? { ...prev, input: q } : prev)}
                  className="text-xs bg-orange-50 border border-orange-200 text-orange-600 px-2.5 py-1 rounded-full hover:bg-orange-100 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {q}
                </button>
              ))}
            </div>
          )}

          {/* Input */}
          <div className="px-3 pb-3 flex gap-2 flex-shrink-0">
            <input
              value={chat.input}
              onChange={(e) => setChat((prev) => prev ? { ...prev, input: e.target.value } : prev)}
              onKeyDown={(e) => { if (e.key === "Enter") sendMessage(); }}
              className="flex-1 border border-gray-200 rounded-xl px-3 py-2 text-xs focus:outline-none focus:border-orange-400"
              placeholder="Type a message..."
            />
            <button
              onClick={sendMessage}
              disabled={!chat.input.trim()}
              className="w-9 h-9 flex items-center justify-center bg-orange-500 text-white rounded-xl hover:bg-orange-600 transition-colors cursor-pointer disabled:opacity-40 flex-shrink-0"
            >
              <i className="ri-send-plane-fill text-sm" />
            </button>
          </div>
        </div>
      )}
    </section>
  );
}
